<template>
	<div>
		<default-widget-field v-bind="calendlyFieldProps" v-on="defaultFieldListeners" />
		<div v-if="!isConfirming" class="calendly-inline-widget" :data-url="calendlyURL" :class="{ 'full-size': isFullSizeEmbed }"></div>
		<div v-else>
			<div>You are scheduled</div>
			<Lottie class="animation-container" :width="100" :options="completedAnimation" />
		</div>
	</div>
</template>

<script>
import DefaultWidgetField from './DefaultWidgetField';
import WidgetFieldMixin from './WidgetFieldMixin';
import { CALENDLY_BASE_URL, CALENDLY_EVENT_TYPE } from '../calendly-mini-app.const';
import { CONFIRMATION_REDIRECT_OPTIONS } from '../confirmation-mini-app.const';
import Lottie from '@/assets/lottie/lottie.vue';
import CalendlyConfirm from '@/components/BlockEditorWidget/WidgetFields/assets/calendly-confirm.json';
import WidgetFormService from '@/components/WidgetForm/WidgetFormService';

function isCalendlyEvent(e) {
	return e.origin === CALENDLY_BASE_URL && e.data.event && e.data.event.indexOf(CALENDLY_EVENT_TYPE) === 0;
}

function buildURL(string, isAddCookies, isFullSizeEmbed) {
	try {
		const baseUrl = new URL(string);
		baseUrl.searchParams.set('primary_color', '5D5CFC');
		baseUrl.searchParams.set('text_color', '262626');
		if (!isFullSizeEmbed) {
			baseUrl.searchParams.set('hide_event_type_details', '1');
		}
		if (!isAddCookies) {
			baseUrl.searchParams.set('hide_gdpr_banner', '1');
		}
		return baseUrl.toString().replaceAll('+', '%20');
	} catch (e) {
		return string;
	}
}

export default {
	name: 'CalendlyInputField',
	components: {
		DefaultWidgetField,
		Lottie,
	},
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	mixins: [WidgetFieldMixin],
	computed: {
		completedAnimation() {
			return { animationData: CalendlyConfirm, loop: false };
		},
		metadataOptions() {
			return this.field.metadata.options;
		},
		currentPreviousSteps() {
			return this.previousSteps || this.flatPreviousSteps;
		},
		calendlyLink() {
			return WidgetFormService.processPreviousSteps(this.metadataOptions.calendly_link.value, this.currentPreviousSteps);
		},
		calendlyFieldProps() {
			return { ...this.defaultFieldProps, titleEnabled: false };
		},
		confirmationHandlingOption() {
			return this.metadataOptions.confirmation_handling_option.value;
		},
		isFullSizeEmbed() {
			return this.metadataOptions.is_add_description.enabled;
		},
		isAddCookies() {
			return this.metadataOptions.is_add_cookies.enabled;
		},
		calendlyURL() {
			return buildURL(this.calendlyLink, this.isAddCookies, this.isFullSizeEmbed);
		},
	},
	methods: {
		onEventSchedule(calendlyEvent) {
			switch (this.confirmationHandlingOption) {
				case CONFIRMATION_REDIRECT_OPTIONS.withoutAnimation:
					this.value = {
						event: calendlyEvent.event.uri,
						invitee: calendlyEvent.invitee.uri,
					};
					this.$emit('on-mini-app-finished');
					break;
				case CONFIRMATION_REDIRECT_OPTIONS.defaultPage:
					this.$emit('disable-cancel-button');
					break;
				default:
					this.isConfirming = true;
					setTimeout(() => {
						this.value = {
							event: calendlyEvent.event.uri,
							invitee: calendlyEvent.invitee.uri,
						};
						this.$emit('on-mini-app-finished');
					}, 2000);
			}
			this.value = {
				event: calendlyEvent.event.uri,
				invitee: calendlyEvent.invitee.uri,
			};
			this.$emit('disable-cancel-button');
		},
	},
	async mounted() {
		const newScript = document.createElement('script');
		newScript.id = 'widgetScript';
		newScript.type = 'text/javascript';
		newScript.src = 'https://assets.calendly.com/assets/external/widget.js';
		newScript.async = true;
		document.head.appendChild(newScript);
		window.addEventListener('message', (e) => {
			if (isCalendlyEvent(e)) {
				if (e.data.event === 'calendly.event_scheduled') {
					this.onEventSchedule(e.data.payload);
				}
			}
		});
	},
	data: () => ({
		isConfirming: false,
	}),
};
</script>
<style scoped lang="scss">
.calendly-inline-widget {
	height: 600px;
	&.full-size {
		height: 800px;
	}
	min-width: 320px;
}
</style>
<style lang="scss"></style>
